import { TextField } from "@mui/material";
import { StylesProvider } from "@material-ui/core/styles";
const TextFiealdInput = (props: any) => {
  const {
    style,
    onBlur,
    pageOption,
    handleChange,
    touched,
    onchange,
    setFieldValue,
    disable,
    uppercase,
    label,
    notRequire,
    readOnly,
    defaultValues,
    handchange,
    handleBlur,
    borderless,
    alignend,
    errors,
    values,

    name,
  } = props;

  return (
    <>
      <StylesProvider injectFirst>
        <div className="field_item">
          <label className="f4">
            {label} {notRequire || borderless ? "" : <span>*</span>}
          </label>
          <TextField
            type="text"
            placeholder={label}
            name={name}
            disabled={disable}
            defaultValue={defaultValues ? defaultValues : ""}
            className="custom_textfield"
            onBlur={handleBlur}
            error={touched[name] && errors[name] ? true : false}
            helperText={touched[name] && errors[name] ? errors[name] : ""}
            onChange={handleChange}
            value={values[name]}
          />
        </div>
      </StylesProvider>
    </>
  );
};
export default TextFiealdInput;
